const translations = {
  fr: {
    general: {
      menu: {
        dashboard: 'Tableau de bord',
        campaigns: 'Campagnes',
        proposedCampaigns: 'Proposées',
        purchasedCampaigns: 'Achetées',
        methodology: 'Méthodologie',
        tutorials: 'Tutoriels',
      },
    },
  },
  en: {
    general: {
      menu: {
        dashboard: 'Dashboard',
        campaigns: 'Campaigns',
        proposedCampaigns: 'Proposed',
        purchasedCampaigns: 'Purchased',
        methodology: 'Methodology',
        tutorials: 'Tutorials',
      },
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/i18n/general.js